import { DEFAULT_FILTER, DEFAULT_PAGE, DEFAULT_SORT } from '@ricoh/ria.client.core/constants/component/grid';

import type { CreateQueryRequestOptions, QueryRequestData, ServerNextRequest, ServerQueryRequest } from './_query.type';

import { createFilterParam } from './_filter';
import { createSortParam } from './_sort';

/**
 * Create QueryRequest from QueryRequestData.
 *
 * @param {QueryRequestData} query Query RequestData.
 * @param {CreateQueryRequestOptions} options Options.
 *
 * @returns {ServerQueryRequest} QueryRequest.
 */
export function createQueryRequest(
  { page = DEFAULT_PAGE, sort = DEFAULT_SORT, filter = DEFAULT_FILTER }: QueryRequestData,
  { transformSort, transformFilter }: CreateQueryRequestOptions = {},
): ServerQueryRequest {
  return {
    headers: {
      'X-PageSize': page.take,
    },

    params: {
      page: page.skip / page.take + 1,
      sort: createSortParam(sort, transformSort),
      filter: createFilterParam(filter, transformFilter),
    },
  };
}

/**
 * Create NextRequest from RequestData.
 *
 * @param {string | undefined} nextToken Next token.
 *
 * @returns {ServerNextRequest} NextRequest.
 */
export function createNextRequest(nextToken?: string): ServerNextRequest {
  return {
    headers: {
      'X-NextToken': nextToken,
    },
  };
}
